import IMAPOptionsItem         from "./Collections/IMAPOptionsItem";
import ImapHTTPService         from "./HTTP/IMAPOptionsHTTPService";
import IMAPOptionsHTTPMappings from "./HTTP/IMAPOptionsHTTPMappings";
import NotificationsController from "@/js/Webmail/Notifications/NotificationsController";

export { ImapOptionsController as default };

/**
* Imap Options Controller
*
* Fetches Imap Security data from the backend server
*
* @author      fheitor <fabio-h-nascimento@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/

class ImapOptionsController {
  /**
   * Imap Security Options
   *
   * @public
   *
   * @type {IMAPOptionsItem}
   *
   * @since 7.0.0
   */
  options = new IMAPOptionsItem();

  /**
   * HTTP Mapping object
   *
   * @private
   *
   * @type {IMAPOptionsHTTPMappings}
   *
   * @since 7.0.0
   */
  http_mapping = new IMAPOptionsHTTPMappings();

  /**
   * HTTP Service object
   *
   * @private
   *
   * @type {ImapHTTPService}
   *
   * @since 7.0.0
   */
  http_service = new ImapHTTPService();

  /**
   * Fetches Imap options from the server to set the imap options entity object
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise<Boolean>}
   */
  async fetchSettings() {
    let response = await this.http_service.fetch();
    return this.processResponse(response);
  }

  /**
   * Calls the server to enable imap option
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise<Boolean>}
   */
  async enableImap() {
    let response = await this.http_service.enable();
    return this.processResponse(response);
  }

  /**
   * Calls the server to disable imap option
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise<Boolean>}
   */
  async disableImap() {
    let response = await this.http_service.disable();
    return this.processResponse(response);
  }

  /**
   * Calls the server to change the current imap option
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise<Boolean>}
   */
  async changeImap(services_enabled) {
    return services_enabled ? await this.enableImap() : await this.disableImap();
  }

  /**
   * Processes http response
   *
   * @private
   *
   * @since 7.0.0
   *
   * @return {Boolean}
   */
  processResponse(response) {
    if (response.messages) {
      NotificationsController.addMessage('notifications.', response.messages);
    }

    if (response.success === true) {
      this.http_mapping.map(this.options, response);
    }

    return response.success;
  }
}